import { selectShiftApplication,insertShiftApplication,updateShiftApplication,deleteShiftApplication,selectApplication,choiceShiftList,choiceShiftCar,choiceShiftDriver,selectShiftList,insertShift,updateShift,deleteShift,selectShift } from "../../api/config/modules/ShiftSchedule";

const state = {
  selectShiftApplication: {},
  insertShiftApplication: {},
  updateShiftApplication: {},
  deleteShiftApplication: {},
  selectApplication: {},
  choiceShiftList: {},
  choiceShiftCar: {},
  choiceShiftDriver: {},
  selectShiftList: {},
  insertShift: {},
  updateShift: {},
  deleteShift: {},
  selectShift: {}
};

const mutations = {
  SET_SELECTSHIFTAPPLICATION: (state, selectShiftApplication) => {
    state.selectShiftApplication = selectShiftApplication;
  },
  SET_INSERTSHIFTAPPLICATION: (state, insertShiftApplication) => {
    state.insertShiftApplication = insertShiftApplication;
  },
  SET_UPDATESHIFTAPPLICATION: (state, updateShiftApplication) => {
    state.updateShiftApplication = updateShiftApplication;
  },
  SET_DELETESHIFTAPPLICATION: (state, deleteShiftApplication) => {
    state.deleteShiftApplication = deleteShiftApplication;
  },
  SET_SELECTAPPLICATION: (state, selectApplication) => {
    state.selectApplication = selectApplication;
  },
  SET_CHOICESHIFTLIST: (state, choiceShiftList) => {
    state.choiceShiftList = choiceShiftList;
  },
  SET_CHOICESHIFTCAR: (state, choiceShiftCar) => {
    state.choiceShiftCar = choiceShiftCar;
  },
  SET_CHOICESHIFTDRIVER: (state, choiceShiftDriver) => {
    state.choiceShiftDriver = choiceShiftDriver;
  },
  SET_SELECTSHIFTLIST: (state, selectShiftList) => {
    state.selectShiftList = selectShiftList;
  },
  SET_INSERTSHIFT: (state, insertShift) => {
    state.insertShift = insertShift;
  },
  SET_UPDATESHIFT: (state, updateShift) => {
    state.updateShift = updateShift;
  },
  SET_DELETESHIFT: (state, deleteShift) => {
    state.deleteShift = deleteShift;
  },
  SET_SELECTSHIFT: (state, selectShift) => {
    state.selectShift = selectShift;
  },
};

const actions = {
  GET_SELECTSHIFTAPPLICATION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectShiftApplication(data)
        .then((res) => {
          commit("SET_SELECTSHIFTAPPLICATION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTSHIFTAPPLICATION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      insertShiftApplication(data)
        .then((res) => {
          commit("SET_INSERTSHIFTAPPLICATION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATESHIFTAPPLICATION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateShiftApplication(data)
        .then((res) => {
          commit("SET_UPDATESHIFTAPPLICATION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETESHIFTAPPLICATION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteShiftApplication(data)
        .then((res) => {
          commit("SET_DELETESHIFTAPPLICATION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTAPPLICATION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectApplication(data)
        .then((res) => {
          commit("SET_SELECTAPPLICATION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CHOICESHIFTLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      choiceShiftList(data)
        .then((res) => {
          commit("SET_CHOICESHIFTLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CHOICESHIFTCAR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      choiceShiftCar(data)
        .then((res) => {
          commit("SET_CHOICESHIFTCAR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CHOICESHIFTDRIVER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      choiceShiftDriver(data)
        .then((res) => {
          commit("SET_CHOICESHIFTDRIVER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTSHIFTLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectShiftList(data)
        .then((res) => {
          commit("SET_SELECTSHIFTLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTSHIFT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      insertShift(data)
        .then((res) => {
          commit("SET_INSERTSHIFT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATESHIFT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateShift(data)
        .then((res) => {
          commit("SET_UPDATESHIFT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETESHIFT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteShift(data)
        .then((res) => {
          commit("SET_DELETESHIFT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTSHIFT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectShift(data)
        .then((res) => {
          commit("SET_SELECTSHIFT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
